<template>
  <!-- Header -->
  <Header :HeaderTitle="'Events'" :ShowLogoutButton="true"></Header>

  <!-- Content -->
  <main class="content-wrap events-screen">
    <!-- Search -->
    <div class="input-group events-search">
      <input
        @input="setSearchValue($event)"
        :value="searchInput"
        type="text"
        class="form-control"
        placeholder="Search"
        aria-label="Search events"
      />
      <button
        v-if="searchInput"
        @click="clearSearch"
        class="input-group-text"
        type="button"
        aria-label="Clear search"
      >
        <img
          src="../assets/images/search/icon-clear-search.svg"
          alt=""
          class="icon-clear-search"
        />
      </button>
    </div>
    <Loader v-if="loading" />

    <!-- Filters -->
    <div class="program-filters">
      <Switch 
        :buttons="['All', 'Past', 'Today', 'Future']"
        v-model="eventsFilter"
        @update:modelValue="filterEvents()"
      />
    </div>

    <!-- Event list -->
    <div class="events-list row">
      <!-- Event -->
      <div
        class="col-sm-6 col-lg-4"
        v-for="event in eventsList"
        v-bind:key="event.EventID"
        @click="openEvent(event.EventID)"
      >
        <div class="event">
          <div class="event__img">
            <img
              v-if="
                event.ImageID != undefined &&
                event.ImageID != null &&
                event.ImageID.trim() !== ''
              "
              :src="
                this.eventUrl + '/downloadhandler.ashx?fid=' + event.ImageID
              "
              alt="Event"
            />
            <img
              v-else
              src="../assets/images/event/img-event.png"
              alt="Event"
            />
          </div>

          <div class="event__info">
            <div class="event__name">{{ event.EventName }}</div>
            <div class="event__date">
              {{ formatDate(event.DtStart) + " – " + formatDate(event.DtEnd) }}<span v-if="event.Location"> · {{ event.Location }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll to top btn -->
    <button v-if="showScrollTop" @click="scrollToTop" class="floating-btn" type="button" aria-label="Scroll to top">
      <img src="../assets/images/event/icon-up.svg" alt="" />
    </button>
  </main>
</template>

<script>
import Header from "../components/HeaderComponent.vue";
import Loader from "../components/LoaderComponent.vue";
import PullToRefresh from "pulltorefreshjs";
import Switch from "../components/Switch.vue"; 

export default {
  components: { Header, Loader, Switch },
  name: "EventsView",
  data: () => ({
    events: null,
    eventsList: [],
    eventsFilter: "Today",
    tags: " ",
    eventUrl: process.env.VUE_APP_EVENT_API,
    searchInput: "",
    loading: false,
    showScrollTop: false,
    searchTimer: 0
  }),
  methods: {
    updateScrollTop() {
      this.showScrollTop = window.scrollY > 320;
    },
    setSearchValue(event){
      this.searchInput = event.target.value;
      this.searchEvents();
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    searchEvents(){
      clearTimeout(this.searchTimer);
      
      this.searchTimer = setTimeout(async () => {
        this.loadEvents();
      }, 1000);
    },
    formatDate(date) {
      return new Intl.DateTimeFormat("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric"
      }).format(new Date(date));
    },
    async loadEvents() {
      this.loading = true;

      await fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/GetEventProgram/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            Tags: this.tags,
            Search: this.searchInput != "" ? this.searchInput : " ",
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            this.events = response.data.events.reverse();
            this.filterEvents();

            this.$store.commit("setEvents", {
              events: response.data.events,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error: ", error);
          this.loading = false;
        });
    },
    filterEvents(){
      let eventsFiltered = [];

      switch(this.eventsFilter){
        case "All":
          eventsFiltered = this.events;
          break;
        case "Past":
          this.events.forEach((event) => {
            if(new Date(event.DtEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)){
              eventsFiltered.push(event);
            }
          })
          break;
        case "Today":
          this.events.forEach((event) => {
            if(new Date().setHours(0, 0, 0, 0) >= new Date(event.DtStart).setHours(0, 0, 0, 0) && new Date().setHours(0, 0, 0, 0) <= new Date(event.DtEnd).setHours(0, 0, 0, 0)){
              eventsFiltered.push(event);
            }
          })
          break;
        case "Future":
          this.events.forEach((event) => {
            if(new Date(event.DtStart).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)){
              eventsFiltered.push(event);
            }
          })
          break;
      }

      this.eventsList = eventsFiltered;
    },
    openEvent(id) {
      if (!this.$store.getters.getEvents) return;

      let event = this.$store.getters.getEvents.find(
        (event) => event.EventID === id
      );

      this.$store.commit("setEvent", {
        event: event,
      });

      this.$router.push("/event");
    },
    clearSearch() {
      this.searchInput = "";
      this.loadEvents();
    },
  },
  created() {
    this.loadEvents();
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollTop, { passive: true });
    PullToRefresh.init({
      mainElement: "body",
      distThreshold: 80,
      distMax: 100,
      distReload: 100,
      onRefresh() {
        window.location.reload();
      },
      // iconArrow: ReactDOMServer.renderToString(
      //   <FontAwesomeIcon icon={faSyncAlt} />
      // ),
      // iconRefreshing: ReactDOMServer.renderToString(
      //   <FontAwesomeIcon icon={faSyncAlt} spin={true} />
      // ),
    });
  },
  unmounted() {
    window.removeEventListener("scroll", this.updateScrollTop);
    // Don't forget to destroy all instances on unmout
    // or you will get some glitches.
    PullToRefresh.destroyAll();
  },
};
</script>
